import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import HeadCom from "../../headCom";
import exportDate from "@/components/exportDate.vue";
import canvasWaterRemark from "@/utils/canvasWaterRemark.js";
export default {
  components: {
    HeadCom: HeadCom,
    exportDate: exportDate
  },
  computed: {},
  data: function data() {
    return {
      bankListAll: [],
      pickerOptionsEnd: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      searchDec: {
        sectionNo: '标段(包)编号',
        sectionName: "标段(包)名称",
        bhNo: '保函编号'
      },
      searchValue: {
        bhNo: '',
        sectionName: '',
        sectionNo: '',
        issueStartDate: '',
        issueEndDate: '',
        bankNo: '',
        channel: ''
      },
      showExportMask: false,
      size: 10,
      totleListCount: 1,
      page: 1,
      showBox: false,
      tableDataDec: [],
      tableData: [],
      handlelist: [],
      receiptTypeList: this.publicMethed.receiptType,
      channelList: []
    };
  },
  created: function created() {
    this.searchForm = {};
  },
  mounted: function mounted() {
    this.channelList = this.publicMethed.ownAreasChannel();
    var str = this.userInfo.userName + '\n' + this.publicMethed.formatDateTime(new Date(), 'data');
    canvasWaterRemark.set(str, 'DataTable');
    this.initTableDec();
    this.requestData();
  },
  activated: function activated() {},
  destroyed: function destroyed() {
    canvasWaterRemark.destory('DataTable');
  },
  methods: {
    choseEletter: function choseEletter(item) {
      this.$set(this.searchForm, 'branchName', item.orgName);
    },
    searchBankEletter: function searchBankEletter(value) {
      var _this = this;

      var data = {
        guaranteeId: this.userInfo.enterpriseId
      };
      this.requestAPI.selOrgLetter(data).then(function (res) {
        _this.bankListAll = res.data;

        for (var i = 0; i < _this.bankListAll.length; i++) {
          if (!_this.bankListAll[i]) {
            _this.bankListAll.splice(i, 1);
          }
        }
      }).catch(function () {});
    },
    // 导出报表
    exportData: function exportData() {
      this.showExportMask = true;
    },
    // 搜索按钮
    searchBtn: function searchBtn() {
      for (var key in this.searchValue) {
        delete this.searchForm[key];

        if (this.searchValue[key] != '') {
          this.$set(this.searchForm, key, this.searchValue[key]);
        }
      }

      this.requestData();
    },
    // 重置按钮
    reset: function reset() {
      for (var key in this.searchValue) {
        delete this.searchForm[key];
        this.$set(this.searchValue, key, '');
      }

      this.requestData();
    },
    // 请求已出函 数据
    requestData: function requestData(isExprot) {
      var _this2 = this;

      var data = {
        page: this.page,
        size: this.size
      }; //是否是子账号

      data['applicantType'] = '';
      data['uploadFlag'] = 1;
      data["userType"] = this.userInfo.userType;
      data["orderStatus"] = [7, 9, 11];
      data["enterpriseId"] = this.userInfo.enterpriseId;
      data['warranteeName'] = '';
      data['sectionName'] = '';
      data['sectionNo'] = '';
      data['bhType'] = '';
      data["existType"] = 1;

      if (!isExprot) {
        if (this.searchForm.hasOwnProperty('isExprot')) {
          delete this.searchForm.isExport;
        }
      } else {
        this.searchForm['isExprot'] = 1;
      }

      data = Object.assign(data, this.searchForm);
      this.requestAPI.orderFind(data).then(function (res) {
        var result = res;
        _this2.totleListCount = result.data.totalCount;
        _this2.tableData = result.data.orderList;

        _this2.handleTable(_this2.tableData);
      }).catch(function () {
        _this2.tableData = [];
        _this2.totleListCount = 0;
      });
    },
    handleTable: function handleTable(data) {
      for (var i = 0; i < data.length; i++) {
        var tem = data[i];
        tem["showStatus"] = this.publicMethed.orderStatusList[tem.orderStatus]; // 密函报纸

        if (tem.infoEncodeType == 0) {
          tem.beneficiaryName = "***";
          tem.beneficiaryCreditCode = "***";
          tem.sectionName = "***";
          tem.submitDocumentsDeadline = "***";
          tem.sectionNo = "***";
        }

        tem["guaranteeBusiness"] = this.publicMethed.banhanMode[Number(tem.guaranteeBusiness)];
        tem['amountReceive'] = Number(tem.guaranteePrice) - Number(tem.platformCost) - Number(tem.passageFee);
        this.$set(data, i, tem);
      }
    },
    // 查看订单详情
    viewData: function viewData(Obj) {
      this.$router.push({
        path: "/internalSystem/orderManagement/orderDetail",
        query: {
          orderNo: Obj.orderNo
        }
      });
    },
    handleClick: function handleClick(data) {
      this.viewData(data.row);
    },
    initTableDec: function initTableDec() {
      this.tableDataDec = [{
        'prop': 'orderNo',
        'value': '订单编号',
        'width': '140'
      }, {
        'prop': 'sectionNo',
        'value': '标段(包)编号',
        'width': '150'
      }, {
        'prop': 'sectionName',
        'value': '标段(包)名称',
        'width': '170'
      }, {
        'prop': 'submitDocumentsDeadline',
        'value': '投标文件递交截止日期',
        'width': '170'
      }, {
        'prop': 'amountGuaranteed',
        'value': '保证金金额(万元)',
        'width': '100'
      }, {
        'prop': 'validityBids',
        'value': '投标有效期(天)',
        'width': '100'
      }, {
        'prop': 'bhNo',
        'value': '保函编号',
        'width': '120'
      }, {
        'prop': 'issueTime',
        'value': '出函时间',
        'width': '160'
      }, {
        'prop': 'warranteeName',
        'value': '被保证人名称',
        'width': '120'
      }, {
        'prop': 'bankAccoNoName',
        'value': '担保机构',
        'width': '140'
      }, {
        'prop': 'guaranteeBusiness',
        'value': '保函类型'
      }, {
        'prop': 'passageFee',
        'value': '通道服务费(元)'
      }, {
        'prop': 'platformCost',
        'value': '平台手续费(元)'
      }, {
        'prop': 'amountReceive',
        'value': '担保公司到账金额(元)'
      }];
      this.handlelist = ['查看详情'];
    },
    // 翻页回调函数
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.requestData();
    } // handleTable(data) {
    // 	data.forEach((item) => {
    // 		item.receipType = this.receiptTypeList[item.receipType];
    // 	});
    // },

  }
};